import filesApi from '.'
import { getAuthHeaders } from 'utils/requests'

const listFiles = async (filters = {}) => {
  const headers = { headers: getAuthHeaders() }

  const query = new URLSearchParams()
  if (filters.clientId) query.set('clientId', filters.clientId)
  if (filters.processoId) query.set('processoId', filters.processoId)
  if (filters.despesaId) query.set('despesaId', filters.despesaId)
  // 'unfiled' = só arquivos sem pasta. Omitir = mostra tudo (com e sem pasta).
  if (filters.folderId) query.set('folderId', filters.folderId)

  const qs = query.toString()
  const url = qs ? `/?${qs}` : '/'

  return await filesApi.get(url, headers)
}

export default listFiles
